import React from "react";
import SpeedIcon from "@mui/icons-material/Speed";
import CloudSyncOutlinedIcon from "@mui/icons-material/CloudSyncOutlined";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
import PeopleOutlineOutlinedIcon from "@mui/icons-material/PeopleOutlineOutlined";
import SyncLockIcon from "@mui/icons-material/SyncLock";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import LogoutIcon from "@mui/icons-material/Logout";
import ProductionQuantityLimitsIcon from "@mui/icons-material/ProductionQuantityLimits";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import WineBarIcon from "@mui/icons-material/WineBar";
import { APP_LINK } from "./MenuItems";

export const APP_LINKS = {
  WHOLESALERDASHBOARD: "/wholesaler/dashboard",
  ADDPRODUCT: "/wholesaler/product/add",
  PRODUCTLIST: "/wholesaler/products/list",
  PRODUCTEDIT: "/wholesaler/product/edit/:id",
  PRODUCTDETAIL: "/wholesaler/product/view/:id",
  CUSTOMERLIST: "/wholesaler/customers/list",
  WHOLESALERREPORT: "/wholesaler/wholesaler/report",
  GENERALCUSTOMERS: "/wholesaler/general-customers",
  VIEWWHOLESALER: "/wholesaler/view/profile/:id",
  EDITWHOLESALER: "/wholesaler/edit/profile/:id",
  OTPVERIFYREGISTER: "/wholesaler/otp-verify-register",
  MOBILEOTPVERIFY: "/wholesaler/verify-mobile-otp",
  ADDBARAGGREGATION: "/wholesaler/bar/add",
  EDITBARAGGREGATION: "/wholesaler/bar/edit/:id",
  VIEWBARAGGREGATION: "/wholesaler/bar/view/:id",
  BARCLUBAGGREGATION: "/wholesaler/bars/list",
  CONSUMEDREPORT: "/wholesaler/consumed-report",
  TRANSATIONSlIST: "/wholesaler/transaction-list",
  PRODUCTQUANTITYLIST: "/wholesaler/productQuantity/list",
};

export const items = [
  {
    url: APP_LINK.LOGIN,
  },
  {
    url: APP_LINK.REGISTER,
  },
  {
    url: APP_LINK.FORGOTPASSWORD,
  },
];

const wholesalerMenuItems = [
  {
    key: "WholeSalerdashboard",
    icon: <SpeedIcon />,
    label: "Wholesaler Dashboard",
    url: APP_LINKS.WHOLESALERDASHBOARD,
  },
  {
    key: "productQuantity",
    icon: <ProductionQuantityLimitsIcon />,
    label: "Manage Product Stock",
    url: APP_LINKS.PRODUCTQUANTITYLIST,
  },
  {
    key: "products",
    icon: <PeopleOutlineOutlinedIcon />,
    label: "Product Management",
    url: APP_LINKS.PRODUCTLIST,
  },

  {
    key: "barAggregation",
    icon: <CloudSyncOutlinedIcon />,
    label: "Partnered Bars & Clubs",
    url: APP_LINKS.BARCLUBAGGREGATION,
  },
  // {
  //   key: "transactions",
  //   icon: <AccountBalanceWalletIcon />,
  //   label: "Financial Transactions",
  //   url: APP_LINKS.TRANSATIONSlIST,
  // },
  {
    key: "consumptionShots",
    icon: <WineBarIcon />,
    // label: "Beverage Consumption Insights",
    label: "Consumption Insights",
    url: APP_LINKS.CONSUMEDREPORT,
  },
  {
    key: "Report",
    icon: <ReceiptLongOutlinedIcon />,
    label: "Sales & Performance Reports",
    url: APP_LINKS.WHOLESALERREPORT,
  },
  {
    key: "myProfile",
    icon: <PersonSearchIcon />,
    label: "Account Details",
    url: APP_LINKS.EDITWHOLESALER,
  },
  {
    key: "ChangePassword",
    icon: <SyncLockIcon />,
    label: "Update Password",
    url: APP_LINK.CHANGEPASSWORD,
  },
  {
    key: "logOut",
    icon: <LogoutIcon />,
    label: "Sign Out",
    url: APP_LINK.LOGOUT,
  },
];

export default wholesalerMenuItems;
